import React, { useCallback, useState } from 'react';

import { PolicyNote } from '@r1-frontend/ui-react/components/PolicyNote';
import { RenderMessage } from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/RenderMessage';
import * as ST from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/styled';
import {
    IInputValue,
    IRenderFormProps,
    TField,
} from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/types';

export const RenderForm = ({
    policyLink,
    theme,
    fio,
    phone,
    onEditFio,
    onEditPhone,
    onChangeTheme,
    onSendRequest,
    isValid,
    isLoading,
    isError,
    message,
    onChangeHandle,
    openChatHandler,
}: IRenderFormProps) => {
    const [beenStarted, setDataLayer] = useState(false);

    const onChangeHandler = useCallback((stateInput: IInputValue, _setState: (value: IInputValue) => void) => {
        const stateResult = typeof stateInput === 'object' ? stateInput.value : stateInput;
        // @TODO stateInput.value убрать из условия после фикса nameDecorator (useEffect onchange) UI react
        if (!beenStarted && stateResult) {
            onChangeHandle(theme);
            setDataLayer(true);
        }
        _setState(stateInput);
    }, [beenStarted, onChangeHandle, theme]);

    const buttonText = 'Отправить заявку';

    return <>
        <ST.Title data-test='popup-request-theme'>Тема обращения: {theme.label}</ST.Title>
        <ST.Text>
            Оставьте номер телефона, и менеджер вам перезвонит.&nbsp;
            <ST.BreakHack>Или
                <ST.ButtonLookLikeHref onClick={onChangeTheme}>измените тему обращения</ST.ButtonLookLikeHref>.
            </ST.BreakHack>
        </ST.Text>
        <ST.InputContainer>
            <ST.NameInput
                initialValue={fio.value}
                onChange={(stateInput: TField) => onChangeHandler(stateInput, onEditFio)}
                placeholder={'Ваше имя'}
                errorMessage={'Ожидаются только буквы и дефисы'}
                name='request-input-name'
                className={'ym-disable-keys'}
            />
            <ST.PhoneInput
                initialValue={phone.value}
                onChange={(stateInput: TField) => onChangeHandler(stateInput, onEditPhone)}
                placeholder={'Номер телефона'}
                errorMessage={'Введите телефон в формате +7 (999) 999-99-99'}
                name='request-input-phone'
                className={'ym-disable-keys'}
            />
        </ST.InputContainer>

        <RenderMessage isError={isError} message={message} openChatHandler={openChatHandler}/>

        <PolicyNote
            data-test='agreement'
            buttonText={buttonText}
            agreeUrl={policyLink}
        />
        <ST.BaseContainer>
            <ST.BaseButton
                bType={'action'}
                onClick={onSendRequest}
                disabled={!isValid || isLoading}
                data-test='request-button-form'
            >
                {buttonText}
            </ST.BaseButton>
        </ST.BaseContainer>
    </>;
};
